import React from 'react';
import { Route } from 'react-router-dom';

import { FormLayout } from '@/components';

export const SimpleRoute = ({ element, ...rest }: any) => {
    return (
        <Route
            {...rest}
            element={(() => {
                return <FormLayout>{element}</FormLayout>;
            })()}
        />
    );
};
